import CheckoutProductPriceDetails from './CheckoutProductPriceDetails'

export default CheckoutProductPriceDetails
